export const TRANSLATION_PREFIX = 'STATIC.PAGES.ADMIN_INVITE';

// Fallback logo shown in the preview when no logo URL is entered (parity with the Angular page).
export const DEFAULT_LOGO = 'https://app.singular.net/static/dashboard/img/default-user.svg';

// `product_type` values (from the SFDC URL) that pre-check the "enable Attribution" box.
export const ATTRIBUTION_PRODUCT_TYPES = ['Unified', 'Attribution'];

// `account_tier` / `account_tier_override` values that flag the org as mid-market.
export const MIDMARKET_TIERS = ['Not Managed', 'Mid Market'];

// Customer-type tier radio values. These are matched against `orgGroup.tier` with `includes`,
// so 'STANDARD' also matches 'STANDARD_UNIFIED', exactly like the legacy controller.
export const TIERS = {
    ENTERPRISE: 'ENTERPRISE',
    STANDARD: 'STANDARD',
};

export const TIER_RADIO_ITEMS = [
    { id: TIERS.ENTERPRISE, label: `${TRANSLATION_PREFIX}.TIER_ENTERPRISE` },
    { id: TIERS.STANDARD, label: `${TRANSLATION_PREFIX}.TIER_STANDARD` },
];

export const SUCCESS_TOAST_AUTO_CLOSE = 5000;
